import type { DocumentNode } from "graphql";
import { print } from "graphql";

// Removing unnecessary whitespace, commas, and comments from GraphqQL queries.
export function trimGraphqlQuery(str: DocumentNode) {
  return print(str)
    .replace(/([\s,]|#[^\n\r]+)+/g, " ")
    .trim();
}
